// @flow
import * as React from 'react';
import { Portal } from '../../../../../../shared';
import { Timeline } from './timeline';
import { Divider, Stack } from '@mui/material';
import { CallTimeline } from './lib';

type Props = {
  timelines: CallTimeline[],
  onClick: (amount: number) => void,
};
export const Timelines = ({timelines, onClick}: Props) => {
  return (
    <Stack gap={1.5}>
      {timelines.map((item, i) => (
        <React.Fragment key={i}>
          <Timeline timeline={item} onClick={onClick} />
          {i < timelines.length - 1 && <Divider sx={{mt: .5}} />}
        </React.Fragment>
      ))}
    </Stack>
  );
};
